<script>
export default {
    name: "FileInput",
    model: {
        prop: 'file',
        event: 'files-selected',
    },
    props: {
        file: {
            type: [File, Array],
            default: function () {
                return null;
            }
        },
        title: {
            type: String,
            default: function () {
                return '';
            },
        },
    },
    data() {
        return {
            fileList: [],
          tempFiles: [],
        }
    },
    methods: {
        validFile(file) {
            // if (file.raw.type === 'application/pdf' || file.raw.type.startsWith("image/")) {
            //     return true;
            // }
            // this.$message.error("Файл не підтримується, тільки pdf чи зображення");
            // return false
          return true;
        },
        clearFiles() {
          this.fileList = [];
          this.$emit("files-selected", null);
        },
        removeFile() {
            this.fileList = [];
            this.$emit("files-selected", null);
        },
        handleChange(file, fileList) {
          this.tempFiles = fileList.map(f => f.raw);
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            if (this.tempFiles.length > 0) {
              this.$emit("files-selected-for-preview", [...this.tempFiles]);
              this.tempFiles = [];
              this.$refs.uploadChatTrigger.clearFiles();
            }
          }, 100);
        },
    }
}
</script>

<template>
  <div>
    <el-upload
      class="upload-trigger-only"
      ref="uploadChatTrigger"
      action=""
      multiple
      :show-file-list="false"
      :on-change="handleChange"
      :auto-upload="false"
      accept=".pdf, image/*"
    >
      <div slot="trigger">
        <slot name="button"></slot>
      </div>
    </el-upload>
  </div>
</template>

<style scoped>
.upload-trigger-only {
  display: inline-block;
}

/*.custom-upload-container {*/
/*  width: 100%;*/
/*}*/

/*.custom-file-list {*/
/*  display: flex;*/
/*  flex-wrap: wrap;*/
/*  gap: 8px;*/
/*  padding: 5px 10px;*/
/*  background: #f9fafb; !* Цвет фона зоны превью *!*/
/*  border-radius: 8px 8px 0 0;*/
/*}*/

/*.custom-file-item {*/
/*  display: flex;*/
/*  align-items: center;*/
/*  background: #fff;*/
/*  border: 1px solid #e5e7eb;*/
/*  padding: 4px 8px;*/
/*  border-radius: 4px;*/
/*  font-size: 12px;*/
/*}*/

/*.remove-icon {*/
/*  margin-left: 8px;*/
/*  cursor: pointer;*/
/*  color: #ef4444;*/
/*}*/

/*.remove-icon:hover {*/
/*  color: #b91c1c;*/
/*}*/

.file-name {
    text-align: center;
    span {
        font-size: 8px;
        color: #8C8C8C;
        cursor: pointer;
    }
}
.fade-enter-active, .fade-leave-active {
    transition: opacity 1s ease;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
.upload-file {
    width: 100%;
    display: block;
}
* >>> .el-upload--text {
    width: 100%;
}
* >>> .el-upload-list--text {
    text-align: center;
}
* >>> .el-upload {
    display: block;
}
</style>
